import React from 'react';

const ScopeBadge = ({ scope }) => (
  <span className="inline-flex items-center rounded border border-cyan-400/35 bg-cyan-500/10 px-2 py-0.5 text-[11px] font-medium text-cyan-200">
    {scope}
  </span>
);

export default ScopeBadge;
